import { FlexBox } from '../box';
import { styled } from '../styled';
export const AdvertiseRoot = styled(FlexBox)(({ theme, $backgroundImage }) => ({
    padding: theme.spacing(2, 3),
    borderRadius: 8,
    minHeight: 120,
    minWidth: 740,
    width: '100%',
    backgroundImage: $backgroundImage ? `url(${$backgroundImage})` : 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    background: !$backgroundImage
        ? 'linear-gradient(135deg, #166cb8 0%, #4a90e2 100%)'
        : undefined
}));
export const TextSection = styled(FlexBox)({
    minWidth: 500
});
export const LogoImage = styled('img')({
    width: 110,
    height: 110,
    objectFit: 'contain',
    backgroundColor: 'transparent'
});
